export default function Logo(): React.ReactElement {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Neovim</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.63281 8.98139L12.1023 0.380859V40.3704L3.63281 31.8692V8.98139Z"
        fill="url(#paint0_linear_15531_7097)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.3561 9.06282L27.7706 0.385742L27.9446 40.3707L36.4141 31.8695L36.3561 9.06282Z"
        fill="url(#paint1_linear_15531_7097)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0952 0.387695L34.1148 34.1837L27.9531 40.381L5.92188 6.65983L12.0952 0.387695Z"
        fill="url(#paint2_linear_15531_7097)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1034 16.0645L12.0916 17.3956L5.29297 7.30028L5.92249 6.65527L12.1034 16.0645Z"
        fill="black"
        fillOpacity="0.13"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15531_7097"
          x1="7.86753"
          y1="0.380859"
          x2="7.86753"
          y2="40.3704"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#16B0ED" stopOpacity="0.800236" />
          <stop offset="1" stopColor="#0F59B2" stopOpacity="0.837" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_15531_7097"
          x1="32.0923"
          y1="0.385742"
          x2="32.0923"
          y2="40.3707"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DB643" />
          <stop offset="1" stopColor="#367533" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_15531_7097"
          x1="20.0183"
          y1="0.387695"
          x2="20.0183"
          y2="40.381"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#88C649" stopOpacity="0.8" />
          <stop offset="1" stopColor="#439240" stopOpacity="0.84" />
        </linearGradient>
      </defs>
    </svg>
  )
}
